export default __webpack_public_path__ + "static/media/RandomIdeas.ccb00ab3.jpg";